import { FormControl, Grid, RadioGroup, useEventCallback } from '@mui/material';
import { AccordionGeneralityForm } from 'civil-status/view-models/accordion-generality-form';
import { Fragment, memo } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import { FormControlLabel } from '@mui/material';
import { Radio } from '@mui/material';
import ListTwins from '../list/list-twins';
import { SelectChangeEvent } from '@mui/material';

interface TwinsProps {
  disabled?: boolean;
  generality?: AccordionGeneralityForm;
  errorsGenerality?: FormikErrors<AccordionGeneralityForm>;
  touchedGenerality?: FormikTouched<AccordionGeneralityForm>;
  onChangeGenerality: (
    key: keyof AccordionGeneralityForm,
    value: AccordionGeneralityForm[keyof AccordionGeneralityForm]
  ) => void;
  onChangeFieldsGenerality: (values: AccordionGeneralityForm) => void;
}

const TwinsComponent = ({
  generality,
  onChangeGenerality,
  onChangeFieldsGenerality,
  disabled,
  errorsGenerality,
  touchedGenerality,
}: TwinsProps): React.ReactElement => {
  const onChangeRadioTwins = useEventCallback(() => {
    onChangeFieldsGenerality({
      isWithTwins: !Boolean(generality?.isWithTwins),
      currentTwin: !Boolean(generality?.isWithTwins) ? 1 : 0,
      allTwins: 0,
    });
  });

  const handleListTwinsChange = useEventCallback((event: SelectChangeEvent<number>) => {
    onChangeGenerality('allTwins', event.target.value);
  });

  return (
    <Grid xs={12} container spacing={2} item paddingBottom="16px" paddingTop="0px">
      <Grid item xs={6} md={2} display="flex" alignItems="center">
        Nascita gemellare?
      </Grid>
      <Grid item xs={6} md={2}>
        <FormControl component="fieldset">
          <RadioGroup
            row
            aria-label="Gemelli"
            id="isForeign"
            defaultValue={false}
            value={generality?.isWithTwins || false}
            onChange={() => onChangeRadioTwins()}
          >
            <FormControlLabel
              value="false"
              control={<Radio />}
              label="No"
              disabled={disabled || (generality?.currentTwin || 0) > 1 || generality?.isBookTwins}
            />
            <FormControlLabel
              value="true"
              control={<Radio />}
              label="Si"
              disabled={disabled || (generality?.currentTwin || 0) > 1 || generality?.isBookTwins}
            />
          </RadioGroup>
        </FormControl>
      </Grid>
      {generality?.isWithTwins ? (
        <Fragment>
          <Grid item xs={6} md={2} display="flex" alignItems="center">
            {generality?.currentTwin === 1 ? 'Gemello' : 'Gemelli'}
            &nbsp;<b>{generality?.currentTwin}</b>&nbsp; di &nbsp;
            {generality?.currentTwin === 1 ? '' : <b>{generality?.allTwins}</b>}
          </Grid>
          {generality?.currentTwin === 1 ? (
            <Grid item xs={6} md={2}>
              <ListTwins
                value={generality?.allTwins || 0}
                onChange={handleListTwinsChange}
                disabled={disabled || generality?.isBookTwins}
                error={Boolean(errorsGenerality?.allTwins) && touchedGenerality?.allTwins}
                required
              />
            </Grid>
          ) : undefined}
        </Fragment>
      ) : undefined}
    </Grid>
  );
};

TwinsComponent.displayName = 'Form twins component';

const Twins = memo(TwinsComponent);

export default Twins;
